module.exports = __webpack_public_path__ + "img/8.2ec34fd5.webp";